module.exports = __webpack_public_path__ + "img/flexsale-refined-8.5bc55cf0.png";